export default __webpack_public_path__ + "static/botella_3-47f78a0bdfe113f1761fad278f34b9fc.jpg";